import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Shield } from 'lucide-react';

export default function PrivacyPolicyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-40 shadow-md bg-[#FF6B6B]">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-3">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)} className="text-white hover:bg-white/20">
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <Shield className="w-6 h-6 text-white" />
          <h1 className="text-lg font-bold text-white">Política de Privacidade e LGPD</h1>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-sm p-6 md:p-10 space-y-8 text-slate-700 leading-relaxed">
          
          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Política de Privacidade</h2>
            <p className="text-sm text-slate-500 mb-6">Última atualização: Março de 2026</p>
            <p>A <strong>Hit Grill</strong>, inscrita no CNPJ 12.345.678/0001-90, com sede na Avenida Hildebrando de Lima, 699, KM 18, Osasco - SP, CEP 06190-160, é responsável pelo tratamento dos dados pessoais coletados por meio deste cardápio digital e demais canais de atendimento.</p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-3">1. Dados Coletados</h3>
            <p>Coletamos os seguintes dados pessoais para a finalidade de processamento de pedidos e entrega:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Nome completo</li>
              <li>CPF (para identificação do pedido)</li>
              <li>Número de telefone/WhatsApp</li>
              <li>Endereço de entrega</li>
              <li>Dados de pagamento (processados por terceiros seguros)</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-3">2. Finalidade do Tratamento</h3>
            <p>Os dados pessoais são utilizados exclusivamente para:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Processar e entregar pedidos realizados</li>
              <li>Entrar em contato sobre o status do pedido</li>
              <li>Emissão de notas fiscais</li>
              <li>Cumprimento de obrigações legais e regulatórias</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-3">3. Base Legal (LGPD - Lei 13.709/2018)</h3>
            <p>O tratamento dos dados pessoais é realizado com base nas seguintes hipóteses legais previstas na LGPD:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>Execução de contrato:</strong> para o cumprimento do pedido realizado pelo titular</li>
              <li><strong>Obrigação legal:</strong> para cumprimento de obrigações fiscais e tributárias</li>
              <li><strong>Consentimento:</strong> quando aplicável, para envio de comunicações promocionais</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-3">4. Compartilhamento de Dados</h3>
            <p>Seus dados podem ser compartilhados com:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Plataformas de delivery parceiras (iFood, Keeta, 99Food) para processamento de pedidos</li>
              <li>Processadores de pagamento para conclusão de transações</li>
              <li>Autoridades fiscais, quando exigido por lei</li>
            </ul>
            <p className="mt-2">Não comercializamos, vendemos ou alugamos dados pessoais a terceiros.</p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-3">5. Armazenamento e Segurança</h3>
            <p>Os dados são armazenados em servidores seguros com criptografia e acesso restrito. Adotamos medidas técnicas e organizacionais para proteger seus dados contra acesso não autorizado, perda ou destruição.</p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-3">6. Direitos do Titular</h3>
            <p>Conforme a LGPD, você tem direito a:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Confirmar a existência de tratamento de dados</li>
              <li>Acessar seus dados pessoais</li>
              <li>Corrigir dados incompletos ou desatualizados</li>
              <li>Solicitar a anonimização, bloqueio ou eliminação de dados desnecessários</li>
              <li>Solicitar a portabilidade dos dados</li>
              <li>Revogar o consentimento a qualquer momento</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-3">7. Retenção de Dados</h3>
            <p>Os dados pessoais são retidos pelo período necessário para cumprir as finalidades descritas nesta política, bem como para atender obrigações legais e regulatórias (mínimo de 5 anos para fins fiscais).</p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-3">8. Contato</h3>
            <p>Para exercer seus direitos ou esclarecer dúvidas sobre o tratamento de dados, entre em contato:</p>
            <ul className="list-none mt-2 space-y-1">
              <li><strong>E-mail:</strong> contato@pdv.hitgrill.com.br</li>
              <li><strong>Telefone:</strong> +55 11 98308-6866</li>
              <li><strong>Endereço:</strong> Av. Hildebrando de Lima, 699, KM 18, Osasco - SP, CEP 06190-160</li>
            </ul>
          </section>

        </div>
      </main>

      <footer className="max-w-4xl mx-auto px-4 py-6 text-center text-xs text-slate-400">
        Hit Grill - CNPJ 12.345.678/0001-90
      </footer>
    </div>
  );
}
